module.exports = __webpack_public_path__ + "static/media/delete.1433d731.svg";